/** Touch, drag, and horizontal wheel on carousel tracks. */

const SWIPE_THRESHOLD = 70;
const SWIPE_LOCK_MS = 300;
const WHEEL_THRESHOLD = 30;

export const addCarouselSwipeEvents = (element, { isActive, getDirection, changeSlide }) => {
    let startX;
    let startY;
    let dragging = false;
    let hasChangedSlide = false;
    let locked = false;

    const changeFromDelta = (delta) => changeSlide(getDirection(delta));

    const lock = () => {
        locked = true;
        setTimeout(() => {
            locked = false;
        }, SWIPE_LOCK_MS);
    };

    element.addEventListener(
        'touchstart',
        (e) => {
            if (!isActive()) return;
            const touch = e.changedTouches[0];
            startX = touch.pageX;
            startY = touch.pageY;
        },
        { passive: true },
    );

    element.addEventListener(
        'touchend',
        (e) => {
            if (!isActive()) return;
            const touch = e.changedTouches[0];
            const dx = touch.pageX - startX;
            const dy = touch.pageY - startY;
            if (Math.abs(dx) >= SWIPE_THRESHOLD && Math.abs(dy) <= SWIPE_THRESHOLD) {
                changeFromDelta(dx);
            }
        },
        { passive: true },
    );

    element.addEventListener('mousedown', (e) => {
        if (!isActive()) return;
        dragging = true;
        hasChangedSlide = false;
        startX = e.pageX;
        document.body.style.userSelect = 'none';
    });

    element.addEventListener('mousemove', (e) => {
        if (!dragging || hasChangedSlide || locked || !isActive()) return;
        const dx = e.pageX - startX;
        if (Math.abs(dx) <= SWIPE_THRESHOLD) return;
        changeFromDelta(dx);
        hasChangedSlide = true;
        lock();
    });

    const stopDrag = () => {
        dragging = false;
        document.body.style.userSelect = '';
    };

    element.addEventListener('mouseup', stopDrag);
    element.addEventListener('mouseleave', stopDrag);

    element.addEventListener('wheel', (e) => {
        if (!isActive() || locked || Math.abs(e.deltaX) <= WHEEL_THRESHOLD) return;
        changeFromDelta(-e.deltaX);
        lock();
    });
};
